import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import { Grid } from "@mui/material";
import ListHoursAvailables from "./ListHoursAvailables";
import InformationProcedimiento from "src/Professional/InformationProcedimiento";
import ProfessionalPhoto from "src/Professional/ProfessionalPhoto";
import { cardBase, cardHeader } from "src/shared/styles/cardStyles";
import { getImage } from "src/shared/global/pcd-img";

export default function CardProcedimiento({ professional }) {
  return (
    <Card sx={{ ...cardBase }}>
      <CardHeader
        style={{ ...cardHeader }}
        // title={<div style={{ fontSize: 12, }}><strong>Particular: </strong> {professional.valorParticular?.replace(",", ".") || 'no disponible'}</div>}
        title={
          <div
            style={{
              fontSize: 12,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {" "}
            <div>
              {professional.valorParticular != null ? <strong>Particular: </strong> : <></>}{" "}
              {professional.valorParticular?.replace(",", ".") || " "}
            </div>
            {process.env.REACT_APP_SEDE == "Calama" ? (
              <></>
            ) : (
              <div>
                <small>Sucursal: </small>
                <strong style={{ textShadow: "1px 1px 1px #666666" }}>
                  {professional.sede}
                </strong>
              </div>
            )}
          </div>
        }
      />
      <CardContent style={{ backgroundColor: "#F9FAFB" }}>
        <Grid style={{ display: "flex", alignItems: "center" }}>
          <ProfessionalPhoto
            image={getImage(professional.aseDescrip, professional.imagen)}
            alt={professional.ptdNombre}
            rut={professional.ptdRut}
          />
          <Grid item style={{ marginLeft: 12 }}>
            <InformationProcedimiento professional={professional} />
          </Grid>
        </Grid>
      </CardContent>
      <CardActions style={{ padding: "8px 12px" }}>
        <ListHoursAvailables
          professional={professional}
          hours={professional?.horas}
        />
      </CardActions>
    </Card>
  );
}
